import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ZoomableHeaderComponent } from './zoomable-header/zoomable-header.component';
import { ZoomableLayerComponent } from './zoomable-layer/zoomable-layer.component';
import { ZoomableService } from './services/zoomable.service';
import { ZoomableDirective } from './directives/zoomable.directive';

@NgModule({
  imports: [CommonModule, ZoomableHeaderComponent, ZoomableLayerComponent],
  declarations: [ZoomableDirective],
  exports: [ZoomableHeaderComponent, ZoomableLayerComponent, ZoomableDirective],
  providers: [ZoomableService],
})
export class ZoomableModule {}
